import { NAME } from "./constants";

export const GET_USER_DATA = NAME + "_GET_USER_DATA";
export const UPDATE_USER_DATA = NAME + "_UPDATE_USER_DATA";
